import { mixed, number, object, string } from 'yup';
import { AdUnitType, IdNamePairErrorModel } from '../../../../../../@data/store/schema';
import { PartnerCodesValidationSchema } from '../../../../../../@data/store/schema/viewmodels/PartnerCodesValidationModel';
import { isTythonSelfServeUser } from '../../../../../../@data/utils/checkUserType';
import { ArrayObservableSchemaYupType, StringListSchemaYupType } from '../../../../../../utils/validation';
import { IAdunitViewModel } from './IAdunitViewModel';

export function adunitErrorModel() {
  return object<IAdunitViewModel>().shape({
    name: string().trim().required(),
    channelsSelected: new ArrayObservableSchemaYupType().of(IdNamePairErrorModel),
    storeIds: new StringListSchemaYupType().of(number().integer()),
    distributionPartnerCodes: PartnerCodesValidationSchema,
    propertySelected: isTythonSelfServeUser() ? string().required() : string(),
    adUnitType: isTythonSelfServeUser() ? mixed<AdUnitType>().required() : string(),
    targetingChannel: number()
      .required()
      .min(1, 'Targeting channel is required')
      .test('sub-channel-required', 'Sub-channel is required', function (value) {
        const { channelTaxonomyValues } = this.parent as IAdunitViewModel;
        if (!value || !channelTaxonomyValues) {
          return true; // Let required() handle missing value
        }
        const selectedChannel = channelTaxonomyValues.find((a) => a.key === value);
        if (!selectedChannel) {
          return true; // Channel not found, skip this validation
        }
        // If the selected channel has sub-channels, it's invalid (user must select a sub-channel)
        const hasSubChannels = channelTaxonomyValues.some((a) => a.parentValue === selectedChannel.value);
        return !hasSubChannels;
      }),
  });
}
